import { api } from "@/api";
import {
  type IJointBillServicePeriodData,
  type IJointBillServicePeriodDataRequestParams,
  type IOverview,
} from "./types";

export const getOverview = async () =>
  (await api.get<IOverview>("/overview")).data;

export const getJointBillServicePeriodData = async (
  data: IJointBillServicePeriodDataRequestParams,
) =>
  (
    await api.get<IJointBillServicePeriodData>(
      `/overview/joint-bill-services/period/${data.periodId}`,
      {
        headers: {
          jointBillServiceId: data.jointBillServiceId,
        },
      },
    )
  ).data;

export const getServiceProviderGroups = async () =>
  (
    await api.get<{ serviceProviderGroups: string[] }>(
      "/service-provider-groups",
    )
  ).data?.serviceProviderGroups;

export const getServiceProviderVisibleCategories = async () =>
  (
    await api.get<{
      serviceProviderCategories: { serviceProviderCategoryId: string }[];
    }>("/service-provider-categories/display")
  ).data?.serviceProviderCategories?.map((i) => i.serviceProviderCategoryId);
